export default __webpack_public_path__ + "static/media/contactResponciveImg.02ef4fb1.png";